import { useEffect } from "react"
import type { NavigateFunction } from "react-router-dom"
import type { ProfileResponse } from "~/api/auth"

export function shouldShowPortraitCelebration(profile: ProfileResponse | null): boolean {
  const dog = profile?.dog_profile
  if (!dog) return false
  return dog.portrait.status === "ready" && !dog.share_celebration_seen_at
}

export function usePortraitCelebrationRedirect(
  profile: ProfileResponse | null,
  navigate: NavigateFunction,
  enabled = true,
) {
  useEffect(() => {
    if (!enabled || !shouldShowPortraitCelebration(profile)) return
    navigate("/onboarding/portrait/celebrate", { replace: true })
  }, [enabled, navigate, profile])
}
